import { createContext, useContext } from 'react';
import { defaultAbility } from './ability';

export const AbilityContext = createContext(defaultAbility);

export function useAbility() {
  return useContext(AbilityContext);
}
